import(/* webpackMode: "eager" */ "/codebuild/output/src594262572/src/apps/webapp/src/app/global-error.tsx");
